import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);
  const sizes: Record<string, string> = {
    sm: 'max-w-sm',
    md: 'max-w-lg',
    lg: 'max-w-2xl'
  };
  return <AnimatePresence data-id="element-602">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-603">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-604" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} transition={{
        duration: 0.2
      }} className={`relative w-full ${sizes[size]} bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl shadow-2xl`} data-id="element-605">
            {title && <div className="flex items-center justify-between px-6 py-4 border-b border-[#2A2A2A]" data-id="element-606">
                <h2 className="text-lg font-semibold text-white" data-id="element-607">{title}</h2>
                <button onClick={onClose} className="p-1 text-[#666666] hover:text-white rounded-lg transition-colors" aria-label="Đóng" data-id="element-608">
                  <XIcon className="w-5 h-5" data-id="element-609" />
                </button>
              </div>}
            <div className="p-6" data-id="element-610">{children}</div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}